import React, { useMemo } from 'react';
import classNames from 'classnames';
import Step from '@axa-asia/emma-stylesheet/lib/components/Step/Step';
import './style.scss';
import ovalImg from './oval@3x.png';

export type StepContext = { list: { item: string }[] };

export interface WhiteHorizontalStepProps {
  stepContext: StepContext;
  activeIndex: number;
}

export const WhiteHorizontalStep = ({
  stepContext,
  activeIndex,
}: WhiteHorizontalStepProps) => {
  const { list } = stepContext;

  return (
    <div className="White-Horizontal-Step">
      {list.map((step, index) => {
        const number = index + 1;
        const isFirst = index === 0;
        const isLast = index === list.length - 1;
        const isActive = activeIndex >= index;

        return (
          <div className="White-Horizontal-Step__item" key={index}>
            <div className="White-Horizontal-Step__item-circle-wrapper">
              {isFirst && <div className="White-Horizontal-Step__spacing" />}
              {!isFirst && (
                <div className="White-Horizontal-Step__line">
                  <div className="White-Horizontal-Step__line-inner"></div>
                </div>
              )}

              <div
                className={classNames({
                  'White-Horizontal-Step__item-circle': true,
                  'White-Horizontal-Step__item-circle--first': isFirst,
                  'White-Horizontal-Step__item-circle--last': isLast,
                  'White-Horizontal-Step__item-circle--active': isActive,
                })}
              >
                <span className="White-Horizontal-Step__item-circle-label">
                  {isActive ? (
                    <img
                      alt=""
                      className="White-Horizontal-Step__item-circle-label-img"
                      src={ovalImg}
                    />
                  ) : (
                    number
                  )}
                </span>
              </div>

              {!isLast && (
                <div className="White-Horizontal-Step__line">
                  <div className="White-Horizontal-Step__line-inner"></div>
                </div>
              )}
              {isLast && <div className="White-Horizontal-Step__spacing" />}
            </div>

            <div className="White-Horizontal-Step__item-label">{step.item}</div>
          </div>
        );
      })}
    </div>
  );
};
